import config from '../../config/config';
import { isEqual } from 'lodash';
import moment from 'moment';
import { createQueryParams } from '@nexio/emvio-util-app';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';

export const FRAUD_LOAD = 'FRAUD/FRAUD_LOAD';
export const FRAUD_SUCCESS = 'FRAUD/FRAUD_SUCCESS';
export const FRAUD_FAILURE = 'FRAUD/FRAUD_FAILURE';

export const FRAUD_COUNT_FAILURE = 'FRAUD/FRAUD_COUNT_FAILURE';
export const FRAUD_COUNT_LOAD = 'FRAUD/FRAUD_COUNT_LOAD';
export const FRAUD_COUNT_SUCCESS = 'FRAUD/FRAUD_COUNT_SUCCESS';

export const REQUEST_FRAUD_FAILURE = 'FRAUD/REQUEST_FRAUD_FAILURE';
export const REQUEST_FRAUD_LOAD = 'FRAUD/REQUEST_FRAUD_LOAD';
export const REQUEST_FRAUD_SUCCESS = 'FRAUD/REQUEST_FRAUD_SUCCESS';

export function requestFraud() {
    return {
        failureActionTypeOrCreator: requestFraudFailureActionCreator,
        fetchParams: {
            method: 'POST',
            url: `${config.emailApiUrl}/requestFraud`
        },
        loadActionTypeOrCreator: REQUEST_FRAUD_LOAD,
        successActionTypeOrCreator: REQUEST_FRAUD_SUCCESS
    };
}

export function requestFraudFailureActionCreator(error) {
    return {
        error,
        type: REQUEST_FRAUD_FAILURE
    };
}

export const fetchUrl = `${config.transactionsApiUrl}`;

export function isTransactionNegative(amount, type) {
    return amount < 0 || isEqual(type.toLowerCase(), 'refund');
}

export function getFraudCountSuccessActionCreator(results) {
    return {
        count: results,
        type: FRAUD_COUNT_SUCCESS
    };
}

export function getFraudCountFailureActionCreator(error) {
    return {
        error,
        type: FRAUD_COUNT_FAILURE
    };
}

export function getFraudCount(merchantIds) {
    const filters = [
        {
            id: 'kount.status',
            value: 'R'
        },
        {
            id: 'transactionStatus',
            value: 11
        },
        {
            id: 'transactionDate',
            value: {
                endDate: moment.utc().endOf('day'),
                startDate: moment.utc().subtract(3, 'day')
            }
        }
    ];

    const queryParamsString = createQueryParams({
        dateKey: 'transactionDate',
        filters,
        merchantIds,
        page: 0,
        pageSize: 10
    });

    return {
        failureActionTypeOrCreator: getFraudCountFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}/count${queryParamsString}`
        },
        loadActionTypeOrCreator: FRAUD_COUNT_LOAD,
        successActionTypeOrCreator: getFraudCountSuccessActionCreator
    };
}

export function getFraud(filters, page, pageSize, sorters, merchantIds, columns) {
    const queryParamsString = createQueryParams({
        dateKey: 'transactionDate',
        filters,
        merchantIds,
        page,
        pageSize,
        sorters,
        columns
    });

    return {
        failureActionTypeOrCreator: getFraudFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: FRAUD_LOAD,
        successActionTypeOrCreator: getFraudSuccessActionCreator
    };
}

export function getFraudSuccessActionCreator(results) {

    return buildTableSuccessActionBasedOnCount(results, FRAUD_SUCCESS, 'fraud');
}

export function getFraudFailureActionCreator(error) {
    return {
        error,
        type: FRAUD_FAILURE
    };
}
